<template>
  <v-container class="branch-on-table main-cities">
    <img
      :src="instance.preload.logo"
      class="mx-auto rounded-circle"
      width="200px"
    />
    <citys-branch
      :instance="instance"
      :service="service"
      :ciudades="ciudads"
      v-if="ciudad.slug === ''"
      @setCiudad="setCiudad($event)"
    />
    <citys-branch-suppliers
      :ciudad="ciudad"
      :ciudades="ciudads"
      :suppliers="instance.suppliers_on_table"
      @setCiudad="setCiudad($event)"
      v-if="ciudad.slug !== ''"
    />
  </v-container>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import CitysBranch from "../components/branch/CitysBranch.vue";
import { track } from "../services/track-custom";
import CitysBranchSuppliers from "../components/branch/CitysBranchSuppliers";

export default {
  components: { CitysBranchSuppliers, CitysBranch },
  name: "BranchOnTable",
  beforeRouteLeave(to, from, next) {
      if (this.ciudad.slug !== '' && to.name === 'Main'){
        this.ciudad = { slug: "", label: "" };
        if (this.ciudads.length > 1) next(false);
        else next();
      } else {
        next();
      }
  },
  data() {
    return {
      back_supplier_id: 0,
      ciudads: [],
      ciudad: { slug: "", label: "" }
    };
  },
  computed: {
    ...mapState('customer', ["instance", "supplier"]),
    ...mapState('order', ["service"]),
    ...mapState('ontable', ['flatSavedDataIndexedDb'])
  },
  created() {
    this.setMenuDigital();
    this.back_supplier_id = this.supplier.id;
    this.SetSupplier({ id:0 });
    this.instance.suppliers_on_table.forEach(element => {
      this.addCiudad(element.ciudad_obj);
    });
    if (this.ciudads.length === 1) this.ciudad = this.ciudads[0];

    let queryParams = this.$route.query;
    if(queryParams.city && queryParams.city.length > 0){
      const existe = this.ciudads.find(item => item.slug == queryParams.city);
      if(existe && existe.slug && existe.slug.length > 0)
      this.ciudad = existe
    }
  },
  methods: {
    ...mapMutations('template', [ "SetLoading", "TemplateActiveHeader",  "SetAppClass"]),
    ...mapMutations('customer', [  "SetSupplier"]),
    ...mapActions('order', ["setMenuDigital", "setBook"]),
    ...mapMutations('shared', ["openMenuTop"]),

    setCiudad(val) {
      this.ciudad = val;
    },
    addCiudad(ciudad) {
      if (ciudad === null) {
        ciudad = { slug: "null", label: "" };
      }
      const ciudad_exist = this.ciudads.find(
        element => element.slug === ciudad.slug
      );
      if (ciudad_exist === undefined) {
        this.ciudads.push(ciudad);
      }
    }
  },
  mounted() {
    this.SetLoading(false);
    this.TemplateActiveHeader({
      header_type: "to_main"
    });
    track.trackView(this, `BranchOnTable`, `/branch-on-table`);
    track.trackEventCluvi({}, "branch on table");
    this.SetAppClass("background-app");
  }
};
</script>